import {CSSProperties, ReactNode} from "react";
import {Color, getCssVar} from "@web-libs/features/colors/application/colors";
import cssStyles from "./card.module.css";
import {mergeClassNames} from "@web-libs/util/class-names/class-names";

export type CardProps = {
    children: ReactNode,
    style?: CSSProperties,
    color?: Color,
    spaceBetween?: boolean,
    fullHeight?: boolean,
    alignCenter?: boolean
    padding?: number
    className?: string
}

export const contentColorMap: Partial<{[key in Color] : string}> = {
    lightShade: getCssVar("dark"),
    primary: getCssVar("onPrimary"),
    warn: getCssVar("onWarn"),
}

export const Card = ({children, style, color="lightShade",spaceBetween, alignCenter, fullHeight,padding, className}: CardProps) => {
    const cssColor = getCssVar(color);
    const contentColor = contentColorMap[color] ?? getCssVar("dark");

    const cardStyles: CSSProperties = {
        backgroundColor: cssColor,
        color: contentColor,
        padding: padding,
        ...style
    }

    if(spaceBetween) {
        cardStyles.display = "flex"
        cardStyles.flexDirection = "column"
        cardStyles.justifyContent = "space-between"
    }

    if(alignCenter) {
        cardStyles.display = "flex"
        cardStyles.flexDirection = "column"
        cardStyles.alignItems = "center"
    }

    if(fullHeight) {
        cardStyles.height = "100%"
    }

    return (
        <div className={mergeClassNames(className,cssStyles.card)} style={cardStyles}>
            {children}
        </div>
    )
}
